import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { ACHATS_REDUCER_NAME } from './constants';
import { buildAchatsRedux } from './achatsReducer';

const { reducer } = buildAchatsRedux({});

export const achatsReducer = combineReducers({
    [ACHATS_REDUCER_NAME]: reducer,
});

export const achatsStore = configureStore({
    reducer: achatsReducer,
    devTools: {
        name: 'Achats Store',
    },
});

export type AchatsReducerType = typeof achatsReducer;
export type AchatsStateType = ReturnType<typeof achatsStore.getState>;
export type AchatsAppDispatch = typeof achatsStore.dispatch;
